import { useCallback } from 'react';
import { CbDataRequestInit } from '@cbhq/data-layer/network';

import { EndpointPayload, MockHandlerConfig } from './types';

function getEndpointPathFromUrl(url: string, pathPrefix?: string) {
  const path = new URL(url).pathname;
  const pathSegments = pathPrefix ? path.split(pathPrefix) : [path];
  return pathSegments[pathSegments.length - 1].toLowerCase();
}

type HookReturnType = {
  getMockResponse: <T>(url: string, req?: CbDataRequestInit) => T | unknown;
};

export function useMockHandler(config: MockHandlerConfig, pathPrefix?: string): HookReturnType {
  const getMockResponse = useCallback(
    (url: string, req?: CbDataRequestInit) => {
      const endpoint = getEndpointPathFromUrl(url, pathPrefix);

      const endpointPayload: EndpointPayload = {
        body: req?.body,
        headers: req?.headers as Record<string, string>,
        method: req?.method,
      };

      const requestResolver = config[endpoint];

      return requestResolver(endpointPayload);
    },
    [config, pathPrefix],
  );

  return { getMockResponse };
}
